import { SectionEyebrow } from '#app/shared/ui/data-display/SectionEyebrow.tsx'
import { MainContainer } from '#app/shared/ui/layout/MainContainer.tsx'

const STEPS = [
  {
    number: '01',
    image: '/img/sobreNosotros/card1.png',
    title: 'Seleccionamos',
    description:
      'Selección nacional e internacional de vehículos premium que cumplen estrictos criterios de calidad, estado y procedencia.',
  },
  {
    number: '02',
    image: '/img/sobreNosotros/card2.png',
    title: 'Revisamos',
    description:
      'Cada coche pasa por un proceso exhaustivo de revisión y puesta a punto para garantizar que esté en un estado óptimo estético y mecánico.',
  },
  {
    number: '03',
    image: '/img/sobreNosotros/card3.png',
    title: 'Reacondicionamos',
    description:
      'Corrección de carrocería, pintura y limpieza profunda. Más de 40 fotos en alta resolución y vídeo 360° para total transparencia.',
  },
  {
    number: '04',
    image: '/img/sobreNosotros/card4.png',
    title: 'Entregamos',
    description:
      'Entregamos cada coche con garantías claras y un proceso de compra totalmente visible.',
  },
]

export const Process = () => {
  return (
    <section
      className={`
        bg-white py-16

        lg:py-20
      `}
    >
      <MainContainer
        className={`
          px-4

          sm:px-6
        `}
      >
        <SectionEyebrow>Nuestro proceso</SectionEyebrow>
        <h2
          className={`
            mb-3 text-h3 text-primary-800

            lg:text-h2
          `}
        >
          Vehículos en estado óptimo
        </h2>
        <p className="mb-10 max-w-[640px] text-base-medium text-neutral-600">
          No trabajamos por cantidad. Priorizamos vehículos que realmente
          merecen ser ofrecidos.
        </p>

        <div
          className={`
            grid grid-cols-1 gap-5

            lg:grid-cols-4

            sm:grid-cols-2
          `}
        >
          {STEPS.map((step) => (
            <div key={step.number} className="flex flex-col text-base-medium">
              <div className="relative">
                <img
                  src={step.image}
                  alt={step.title}
                  className="h-[180px] w-full rounded-t-lg object-cover"
                />
                <div
                  className={`
                    absolute -bottom-5 left-5 flex h-10 w-10 items-center
                    justify-center rounded-full bg-primary font-bold text-white
                  `}
                >
                  {step.number}
                </div>
              </div>
              <div
                className={`
                  flex flex-1 flex-col rounded-b-lg border border-t-0
                  border-neutral-75 bg-neutral-25 px-5 pb-6 pt-9
                `}
              >
                <p className="mb-2 font-bold text-primary-800">{step.title}</p>
                <p className={`text-neutral-600`}>{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </MainContainer>
    </section>
  )
}
